import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const decliningAccounts = [
  { name: 'SM Hypermarket Cebu', type: 'Hypermarket', region: 'Cebu', currentMonth: '₱284K', prevMonth: '₱431K', change: -34.1, visits: 2, lastOrder: '12 days ago' },
  { name: 'Puregold Davao', type: 'Supermarket', region: 'Davao', currentMonth: '₱198K', prevMonth: '₱267K', change: -25.8, visits: 3, lastOrder: '8 days ago' },
  { name: 'Robinsons Iloilo', type: 'Supermarket', region: 'Visayas', currentMonth: '₱156K', prevMonth: '₱201K', change: -22.4, visits: 4, lastOrder: '5 days ago' },
  { name: 'Metro Gaisano Cagayan', type: 'Department Store', region: 'Mindanao', currentMonth: '₱134K', prevMonth: '₱172K', change: -22.1, visits: 2, lastOrder: '15 days ago' },
  { name: 'Savemore Batangas', type: 'Supermarket', region: 'Luzon S', currentMonth: '₱112K', prevMonth: '₱143K', change: -21.7, visits: 5, lastOrder: '3 days ago' },
];

export default function DecliningAccountsTable({ onNavigate }) {
  return (
    <div className="card p-4 md:p-5 lg:p-6 table-panel-depth">
      <div className="flex items-center justify-between mb-3 md:mb-4 flex-wrap gap-2">
        <div>
          <h3 className="font-heading font-semibold text-base lg:text-lg text-foreground">Declining Accounts</h3>
          <p className="font-caption text-xs text-muted-foreground mt-0.5">Accounts with significant MoM revenue decline</p>
        </div>
        <Button variant="outline" size="sm" iconName="Users" iconPosition="left" iconSize={14} onClick={() => onNavigate('/account-management')}>
          Manage Accounts
        </Button>
      </div>

      {/* Desktop & Tablet: scrollable table */}
      <div className="hidden sm:block overflow-x-auto custom-scrollbar">
        <table className="w-full min-w-[520px]">
          <thead>
            <tr className="border-b border-border">
              {['Account', 'Type', 'Region', 'Current', 'Previous', 'Change', 'Visits', 'Last Order']?.map((h) => (
                <th key={h} className="text-left py-2 px-2 md:px-3 font-caption text-xs font-semibold text-muted-foreground uppercase tracking-wider whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {decliningAccounts?.map((acc) => (
              <tr key={acc?.name} className="border-b border-border hover:bg-muted transition-colors duration-150">
                <td className="py-2 md:py-3 px-2 md:px-3 font-caption text-xs md:text-sm font-medium text-foreground whitespace-nowrap sticky left-0 bg-card z-10">{acc?.name}</td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <span className="px-2 py-0.5 bg-muted rounded font-caption text-xs text-muted-foreground">{acc?.type}</span>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-caption text-xs text-muted-foreground">{acc?.region}</td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-data text-xs md:text-sm text-foreground">{acc?.currentMonth}</td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-data text-xs md:text-sm text-muted-foreground">{acc?.prevMonth}</td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <div className="flex items-center gap-1 text-destructive">
                    <Icon name="TrendingDown" size={12} color="currentColor" strokeWidth={2.5} />
                    <span className="font-data text-xs md:text-sm font-semibold">{acc?.change}%</span>
                  </div>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-data text-xs md:text-sm text-foreground">{acc?.visits}</td>
                <td className="py-2 md:py-3 px-2 md:px-3 font-caption text-xs text-muted-foreground whitespace-nowrap">{acc?.lastOrder}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile: card-stacked layout */}
      <div className="sm:hidden space-y-2">
        {decliningAccounts?.map((acc) => (
          <div key={acc?.name} className="border border-border rounded-lg p-3 bg-card">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="min-w-0 flex-1">
                <p className="font-caption text-sm font-semibold truncate" style={{ color: '#1E293B' }}>{acc?.name}</p>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="px-1.5 py-0.5 bg-muted rounded font-caption" style={{ fontSize: '10px', color: '#475569' }}>{acc?.type}</span>
                  <span className="font-caption" style={{ fontSize: '10px', color: '#475569' }}>{acc?.region}</span>
                </div>
              </div>
              <div className="flex items-center gap-1 text-destructive flex-shrink-0">
                <Icon name="TrendingDown" size={13} color="currentColor" strokeWidth={2.5} />
                <span className="font-data text-sm font-bold">{acc?.change}%</span>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-x-3 gap-y-1.5">
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Current</p>
                <p className="font-data text-xs font-semibold" style={{ color: '#0F172A' }}>{acc?.currentMonth}</p>
              </div>
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Previous</p>
                <p className="font-data text-xs" style={{ color: '#475569' }}>{acc?.prevMonth}</p>
              </div>
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Visits</p>
                <p className="font-data text-xs" style={{ color: '#1E293B' }}>{acc?.visits}</p>
              </div>
              <div className="col-span-2">
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Last Order</p>
                <p className="font-caption text-xs" style={{ color: '#475569' }}>{acc?.lastOrder}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}